// import node module libraries
import {Button, Card, Form} from 'react-bootstrap';
import {useEffect, useState} from 'react';

const InformationsMedicales = (props) => {
    const {next, previous, initialValues} = props;
    const [formValues, setFormValues] = useState(initialValues || {});

    const [feedbackMessages, setFeedbackMessages] = useState({});

    const handleChange = (field, value, feedbackMessage) => {
        // Update feedbackMessages
        setFeedbackMessages((prevMessages) => ({
            ...prevMessages,
            [field]: feedbackMessage
        }));

        // Update formValues
        const newFormValues = {
            ...formValues,
            [field]: value
        };
        setFormValues(newFormValues);

        // Call the onChange function passed in props with all the values
        props.onChange(newFormValues);
    };

    useEffect(() => {
        // Appeler la fonction onChange passée en props avec toutes les valeurs
        props.onChange(formValues);
    }, [formValues]);

    useEffect(() => {
        if (initialValues) {
            setFormValues(initialValues);
        }
    }, [initialValues]);

    return (
        <div>
            {/* Card */}
            <Card className="mb-3 ">
                <Card.Header className="border-bottom px-4 py-3">
                    <h4 className="mb-0">Informations Médicales</h4>
                </Card.Header>
                {/* Card body */}
                <Card.Body>
                    {/* Maladie congénitale  */}
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="maladie_congenitale">
                            Maladie congénitale
                        </Form.Label>
                        <Form.Control
                            name="maladie_congenitale"
                            as="textarea"
                            placeholder="Préciser la/les maladie(s) congénitale(s) de l'élève"
                            id="maladie_congenitale"
                            style={{height: '100px'}}
                            onChange={(e) => {
                                const value = e.target.value;
                                handleChange('maladie_congenitale', value, '');
                            }}
                        />
                        <Form.Text className="text-muted">
                            L'élève souffre t-il d'une maladie congénitale ? Si oui préciser
                            la/les maladie(s) de l'élève.
                        </Form.Text>
                    </Form.Group>

                    {/* Maladie chronique  */}
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="maladie_chronique">
                            Maladie chronique
                        </Form.Label>
                        <Form.Control
                            name="maladie_chronique"
                            as="textarea"
                            placeholder="Préciser la/les maladie(s) chronique(s) de l'élève"
                            id="maladie_chronique"
                            style={{height: '100px'}}
                            onChange={(e) => {
                                const value = e.target.value;
                                handleChange('maladie_chronique', value, '');
                            }}
                        />
                        <Form.Text className="text-muted">
                            L'élève souffre t-il d'une maladie chronique ? Si oui préciser
                            la/les maladie(s) de l'élève.
                        </Form.Text>
                    </Form.Group>

                    {/* Allergie aliment  */}
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="allergie_aliment">
                            Allergie aliment(s)
                        </Form.Label>
                        <Form.Control
                            name="allergie_aliment"
                            as="textarea"
                            placeholder="Préciser la/les aliment(s) auxquels l'élève est allergique"
                            id="allergie_aliment"
                            style={{height: '100px'}}
                            onChange={(e) => {
                                const value = e.target.value;
                                handleChange('allergie_aliment', value, '');
                            }}
                        />
                        <Form.Text className="text-muted">
                            L'élève est-il allergique à un/des aliments ? Si oui préciser
                            la/les aliment(s).
                        </Form.Text>
                    </Form.Group>

                    {/* Allergie medicament  */}
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="allergie_medicament">
                            Allergie medicament(s)
                        </Form.Label>
                        <Form.Control
                            name="allergie_medicament"
                            as="textarea"
                            placeholder="Préciser la/les médicaments(s) auxquels l'élève est allergique"
                            id="allergie_medicament"
                            style={{height: '100px'}}
                            onChange={(e) => {
                                const value = e.target.value;
                                handleChange('allergie_medicament', value, '');
                            }}
                        />
                        <Form.Text className="text-muted">
                            L'élève est-il allergique à un/des medicaments ? Si oui préciser
                            la/les medicament(s).
                        </Form.Text>
                    </Form.Group>

                    {/* Allergie autres substances  */}
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="allergie_autre_substance">
                            Allergie autres substances
                        </Form.Label>
                        <Form.Control
                            name="allergie_autre_substance"
                            as="textarea"
                            placeholder="Préciser les autres substances auxquelles l'élève est allergique"
                            id="allergie_autre_substance"
                            style={{height: '100px'}}
                            onChange={(e) => {
                                const value = e.target.value;
                                handleChange('allergie_autre_substance', value, '');
                            }}
                        />
                        <Form.Text className="text-muted">
                            L'élève est-il allergique à d'autres substances ? Si oui préciser
                            lesquelles.
                        </Form.Text>
                    </Form.Group>

                    {/* Photocopie carnet vaccination */}
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="photocopie_carnet_vaccination">
                            Photocopie carnet vaccination
                        </Form.Label>
                        <Form.Control
                            name="photocopie_carnet_vaccination"
                            type="file"
                            placeholder="Selectionner la photocopie du carnet de vaccination de l'élève"
                            id="photocopie_carnet_vaccination"
                            accept="application/pdf, image/*"
                            isInvalid={!!feedbackMessages['photocopie_carnet_vaccination']}
                            onChange={(e) => {
                                const file = e.target.files[0];
                                const isValidFile =
                                    file &&
                                    (file.type === 'application/pdf' ||
                                        file.type.startsWith('image/'));
                                const feedbackMessage = isValidFile
                                    ? ''
                                    : "Le fichier sélectionné n'est pas une image ou un fichier PDF.";
                                setFeedbackMessages((prevMessages) => ({
                                    ...prevMessages,
                                    photocopie_carnet_vaccination: feedbackMessage
                                }));

                                if (isValidFile) {
                                    // If the file is an image, create a blob URL to preview it
                                    const fileURL = file.type.startsWith('image/')
                                        ? URL.createObjectURL(file)
                                        : null;
                                    handleChange(
                                        'photocopie_carnet_vaccination',
                                        {file, fileURL},
                                        feedbackMessage
                                    );
                                }
                            }}
                        />

                        <Form.Control.Feedback type="invalid">
                            {feedbackMessages['photocopie_carnet_vaccination']}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Card.Body>
            </Card>

            {/* Button */}
            <div className="d-flex justify-content-between">
                <Button variant="secondary" onClick={previous}>
                    Précédent
                </Button>
                <Button variant="primary" onClick={next}>
                    Suivant
                </Button>
            </div>
        </div>
    );
};
export default InformationsMedicales;
